//#region Util Imports

import * as $ from 'jquery'
import * as _ from 'underscore'
import * as moment from 'moment'

//#endregion

//#region Angular Imports

import { StateService } from "@uirouter/angularjs"

//#endregion

import { SessionModel } from '../modules/api/api.models'

import { DataProvider, ConvertHelper, OperatorComponent, CommonHelper, ConfigHelper, LogHelper } from "../helpers"
import { TimeZoneIdType } from '../helpers/common-helper'

import { SESSION, SESSION_ERROR } from "../models/custom"
import { OpOperator } from "../models/core"
import { Enums } from '../models/common'

export class DataProviderSession {

    //#region Consts

    private readonly LOG_PREFIX = '[SIMAX.DataProvider.Session]'

    //#endregion

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    //Public Methods

    public getSession = (): SESSION => {
        return this.dataProvider.LocalStorage.getOperatorSession()
    }

    public login = (user: string, pwdCrypted: string, key: string, cultureName: string, timeZone: string, stateService: StateService): JQueryPromise<OpOperator> => {
        var deferred: JQueryDeferred<OpOperator> = $.Deferred<OpOperator>()

        var session: SESSION = new SESSION()
        session.guid = ""
        session.status = 0
        session.time = ConvertHelper.dateToString(new Date(), { netFormat: true })
        session.imrWcfAddress = null
        session.error = new SESSION_ERROR()

        var parameters: any[] = []
        parameters.push(Enums.DBCollectorProperties.InitWebSimaxDataProvider)
        parameters.push([])
        parameters.push(Enums.DBCollectorProperties.InitTimeZone)
        parameters.push([timeZone, TimeZoneIdType.Iana]
        )

        const customDBCollectorParameters: any = ConfigHelper.getValue(Enums.SimaxConfigSection.DbCollector, ConfigHelper.Key.InitDbCollectorProperties)

        _.forEach(customDBCollectorParameters, (value: any, key: string) => {
            const parameterKey: string | number = _.isFinite(Number(key)) ? Number(key) : key

            parameters.push(parameterKey, value)
        })

        let errorCodeArgs = []
        errorCodeArgs.push(Enums.DBCollectorLoginParameters.InitDBCollectorProperties)
        errorCodeArgs.push(parameters)
        errorCodeArgs.push(Enums.DBCollectorLoginParameters.InitDBCollectorModule)
        errorCodeArgs.push(Enums.Module.WebSIMAX)
        errorCodeArgs.push(Enums.DBCollectorLoginParameters.LoginVeryficationCode)
        errorCodeArgs.push(key)

        var lsLogin: string = this.dataProvider.LocalStorage.getFromLocalStorage(Enums.SimaxLocalStorageKey.Login)
        var savedDistributors: number[] = this.dataProvider.Distributor.getIdActiveDistributorsLocal()
        if (savedDistributors && savedDistributors.length && lsLogin === user) {
            errorCodeArgs.push(Enums.DBCollectorLoginParameters.InitAllowedDistributors)
            errorCodeArgs.push(savedDistributors)
        }

        session.error.code = errorCodeArgs

        var settings: Enums.SimaxOperatorSetting[] = []

        this.dataProvider.Http
            .sendRequest('Login', { session: session.toJSON(), user: user, pwdCrypted: pwdCrypted, cultureName: cultureName, timeZoneOffset: 0 }, 'LoginResult')
            .then(loginSession => {
                session = new SESSION(loginSession)

                const sessionModel = new SessionModel()

                if (session.status == Enums.SESSION_STATUS.TWO_FACTORY_AUTHORISATION) {
                    deferred.resolve()
                    return
                }

                sessionModel.guid = session.guid
                sessionModel.imrWcfAddress = session.imrWcfAddress

                const time = moment(session.time)

                sessionModel.time = time.add(time.utcOffset(), 'minutes').toDate()
                sessionModel.status = 0
                sessionModel.error = null

                if (lsLogin != user) {
                    this.dataProvider.Distributor.setIdActiveDistributorsLocal([])
                }

                this.dataProvider.LocalStorage.saveOperatorSession(session)

                DataProvider.setSession(sessionModel)

                settings = OperatorComponent.GetBaseSettings()

                this.dataProvider.Operator
                    .getOperatorSettings(0, settings, true, false, [Enums.SimaxOperatorSetting.DictionaryVersion])
                    .then(result => {
                        if (result) {
                            var storedLogin: string = this.dataProvider.LocalStorage.getFromLocalStorage(Enums.SimaxLocalStorageKey.Login)
                            if (storedLogin != user) {
                                this.dataProvider.LocalStorage.removeLoggedOperatorSettings()//Czyścimy ustawienia po poprzednm operatorze
                            }
                            var loggedOperator: OpOperator = this.dataProvider.LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.LoggedOperator)

                            const dictVersionIndex: number = _.indexOf(settings, Enums.SimaxOperatorSetting.DictionaryVersion)
                            const dictVersion: number = result[dictVersionIndex]

                            this.dataProvider.LocalStorage.saveToLocalStorage(Enums.SimaxLocalStorageKey.Login, loggedOperator.login)

                            return this.dataProvider
                                .setDataProviderContext(loggedOperator, cultureName, dictVersion)
                                .then(() => {
                                    deferred.resolve(loggedOperator)
                                })
                                .catch((err: any) => {
                                    LogHelper.warn(this.LOG_PREFIX, 'Unable to set data provider context', err)

                                    return $.Deferred().reject(err).promise()
                                })
                        }
                    })
                    .fail((err: any) => {
                        CommonHelper.openInfoPopup(err.error.msg, 'error', 4000)
                        this.logout()
                    })

            })
            .fail((error) => {
                deferred.reject(error)
                // this.logout()
            })

        return deferred.promise()
    }

    public sendVerificationCode = (user: string, pwdCrypted: string, cultureName: string, timeZone: string, stateService: StateService): JQueryPromise<SESSION> => {
        const deferred: JQueryDeferred<SESSION> = $.Deferred<SESSION>()

        let session: SESSION = new SESSION()
        session.guid = ""
        session.status = 0
        session.time = ConvertHelper.dateToString(new Date(), { netFormat: true })
        session.imrWcfAddress = null
        session.error = new SESSION_ERROR()

        const parameters: any[] = []
        parameters.push(Enums.DBCollectorProperties.InitWebSimaxDataProvider)
        parameters.push([])
        parameters.push(Enums.DBCollectorProperties.InitTimeZone)
        parameters.push([timeZone, TimeZoneIdType.Iana]
        )

        const customDBCollectorParameters: any = ConfigHelper.getValue(Enums.SimaxConfigSection.DbCollector, ConfigHelper.Key.InitDbCollectorProperties)

        _.forEach(customDBCollectorParameters, (value: any, key: string) => {
            const parameterKey: string | number = _.isFinite(Number(key)) ? Number(key) : key

            parameters.push(parameterKey, value)
        })

        let errorCodeArgs = []
        errorCodeArgs.push(Enums.DBCollectorLoginParameters.InitDBCollectorProperties)
        errorCodeArgs.push(parameters)
        errorCodeArgs.push(Enums.DBCollectorLoginParameters.InitDBCollectorModule)
        errorCodeArgs.push(Enums.Module.WebSIMAX)

        const lsLogin: string = this.dataProvider.LocalStorage.getFromLocalStorage(Enums.SimaxLocalStorageKey.Login)
        const savedDistributors: number[] = this.dataProvider.Distributor.getIdActiveDistributorsLocal()

        if (savedDistributors && savedDistributors.length && lsLogin === user) {
            errorCodeArgs.push(Enums.DBCollectorLoginParameters.InitAllowedDistributors)
            errorCodeArgs.push(savedDistributors)
        }

        session.error.code = errorCodeArgs

        this.dataProvider.Http
            .sendRequest('SendVerificationCode', { session: session.toJSON(), user: user, pwdCrypted: pwdCrypted, cultureName: cultureName, timeZoneOffset: 0 }, 'SendVerificationCodeResult')
            .then(loginSession => {
                session = new SESSION(loginSession)
                deferred.resolve(session)
            })
            .fail((error) => {
                deferred.reject(error)
            })

        return deferred.promise()
    }

    public logout = () => {
        CommonHelper.removeValueFromLocalStorage('USER')//DO USUNIECIA!!!
        this.dataProvider.LocalStorage.saveLoggedOperatorSetting(Enums.SimaxOperatorSetting.LoggedOperator, null)
        location.href = '#/login'
        setTimeout(() => {
            window.location.reload()
        }, 100)
    }

    public initDBCollectorProperties = (parameters: any[]): JQueryPromise<void> => {
        return this.dataProvider.sendRequestWithSession('InitDBCollectorProperties', { parameters: parameters }, null).then(() => {
            return
        })
    }

    // Public Methods End
}